(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vestige-product-action"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vestige-product-action')) {
    customElements.define('vestige-product-action', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-vpa-button]');
        this.status = this.querySelector('[data-vpa-status]');
        this.price = this.querySelector('[data-vpa-price]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.button.addEventListener('click', () => this.activate(), options);
        this.observer = new MutationObserver(records => {
          if (records.some(r => !this.contains(r.target))) this.schedule();
        });
        this.observer.observe(document.querySelector('main') || document.body, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','hidden','aria-disabled','aria-busy','class','data-state','value'] });
        document.addEventListener('input', () => this.schedule(), options);
        document.addEventListener('change', () => this.schedule(), options);
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this);
        window.visualViewport?.addEventListener('resize', () => this.measure(), options);
        window.visualViewport?.addEventListener('scroll', () => this.measure(), options);
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort(); this.observer?.disconnect(); this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        document.documentElement.classList.remove('vpa-active');
        document.documentElement.style.removeProperty('--vpa-height');
      }
      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      }
      measure() {
        document.documentElement.style.setProperty('--vpa-height', this.getBoundingClientRect().height + 'px');
        const view = window.visualViewport;
        const editing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName);
        this.style.bottom = editing && view ? Math.max(0, innerHeight - view.height - view.offsetTop) + 'px' : '0px';
      }
      sources() {
        this.productInfo = document.querySelector('product-info[data-update-url="true"]');
        this.form = this.productInfo?.querySelector('product-form form');
        this.submit = this.form?.querySelector('[type="submit"]');
      }
      sync() {
        this.sources();
        if (!this.productInfo || !this.button) return;
        this.hidden = false;
        document.documentElement.classList.add('vpa-active');
        const priceRoot = this.productInfo.querySelector('[id^="price-"] .price');
        const price = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item');
        if (price && this.price.textContent !== price.textContent.trim()) this.price.textContent = price.textContent.trim();
        const busy = this.submit?.classList.contains('loading');
        let mode = 'standard', label = this.submit?.querySelector('span')?.textContent.trim() || this.dataset.unavailable;
        let disabled = !this.submit || this.submit.disabled || this.submit.getAttribute('aria-disabled') === 'true';
        let message = '';
        if (this.hasAttribute('data-requires-design')) {
          // V13: terrain products are designed and added in the Terrain Studio.
          if (this.dataset.available === 'false') { mode = 'sold'; label = this.dataset.sold; disabled = true; }
          else { mode = 'design'; label = this.dataset.design; disabled = !this.dataset.studioUrl; }
        } else if (busy) { mode = 'busy'; label = this.dataset.adding; disabled = true; }
        else {
          const error = this.productInfo.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
          if (error) message = error.textContent;
        }
        this.mode = mode;
        if (this.button.textContent !== label) this.button.textContent = label;
        this.button.disabled = disabled;
        this.button.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (this.status.textContent !== message) this.status.textContent = message;
        this.measure();
      }
      activate() {
        this.sync();
        if (this.button.disabled) return;
        if (this.mode === 'design') window.location.assign(this.dataset.studioUrl);
        else if (this.mode === 'standard') { this.submit.click(); this.sync(); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
